
<h1 mat-dialog-title>{{ 'COMMENT_DIALOG.TITLE' | translate }}</h1>
<div mat-dialog-content>

    <ng-container *ngIf="config">
        <app-comment-section [config]="config" [comments]="comments"
            [isEditable]="true"
            [isShowDeleteButton]="false"
            [isAutoSave]="false"
            [singleComments]="true"
            textareaLabel=""
            [placeholderText]="'COMMENT_DIALOG.PLACEHOLDER' | translate"
        ></app-comment-section>
    </ng-container>

</div>
<div mat-dialog-actions class="flex-h flex-end">
    <button mat-flat-button color="primary" (click)="onOk()">{{ 'GENERAL.OK' | translate }}</button>
    <button mat-flat-button color="accent" [mat-dialog-close]>{{ 'GENERAL.CANCEL' | translate }}</button>
</div>
